import { useTranslation } from "react-i18next";
import { HiOutlineExclamationTriangle } from "react-icons/hi2";

import useTierLimit from "@/hooks/useTierLimit";

type SpaceLeftProps = {
  listCount: number;
  itemsCount: number;
};

const SpacesLeft = ({ listCount, itemsCount }: SpaceLeftProps) => {
  const { t } = useTranslation();
  const { tierLimit } = useTierLimit();
  const spacesLeft = tierLimit - listCount;
  const isSpaceLeft = spacesLeft >= itemsCount;

  return (
    !isSpaceLeft && (
      <div className={"flex shrink-0 items-center gap-1 text-xs text-warning"}>
        <HiOutlineExclamationTriangle className={"size-4 shrink-0"} /> {t("static.notEnoughSpace")} ({listCount}/
        {tierLimit})
      </div>
    )
  );
};

export default SpacesLeft;
